<section
  role="region"
  class="info-company"
  aria-describedby="info-contact-company-title info-contact-company-description"
>
  <header role="banner">
    <h2 role="heading" id="info-contact-company-title" class="info-company__title">
      <span class="line-break">Et si vous contactiez directement</span>
      <span class="highlight highlight--emphasis">les entreprises&nbsp;?</span>
    </h2>

    <p id="info-contact-company-description" class="info-company__text">
      <strong tabindex="-1">Identifiez et contactez les entreprises</strong> qui peuvent être susceptibles de recruter
      même si elles n&apos;ont pas déposé d&apos;offres. Nos outils détectent les entreprises qui vont probablement
      embaucher dans les 6 prochains mois&nbsp;!
    </p>
  </header>

  <ul class="info-company__links">
    <li class="info-company__links-item info-company__links-item--job">
      <a
        class="info-company__links-item__link"
        [href]="urlLaBonneBoite"
        target="_blank"
        aria-label="La bonne boite, vous recherchez un job ?"
        (click)="eventTracker.emit('Bonne Boite')"
      >
        <h3 class="info-company__links-item__title">Vous cherchez un job&nbsp;?</h3>

        <img
          class="info-company__links-item__logo"
          [src]="srcLogoLaBonneBoite | imaginarySrc: 1:198"
          [srcset]="srcLogoLaBonneBoite | imaginarySrc: 4:198"
          alt="Logo de La bonne boite"
          loading="lazy"
        />
      </a>
    </li>
    <li class="info-company__links-item info-company__links-item--apprentice">
      <a
        class="info-company__links-item__link"
        [href]="urlLaBonneAlternance"
        target="_blank"
        aria-label="La bonne alternance, vous cherchez une alternance ?"
        (click)="eventTracker.emit('Bonne Alternance')"
      >
        <h3 class="info-company__links-item__title">Vous cherchez une alternance&nbsp;?</h3>

        <img
          class="info-company__links-item__logo"
          [src]="srcLogoLaBonneAlternance | imaginarySrc: 1:198"
          [srcset]="srcLogoLaBonneAlternance | imaginarySrc: 4:198"
          alt="Logo de La bonne alternance"
          loading="lazy"
        />
      </a>
    </li>
    <li class="info-company__links-item info-company__links-item--youzful">
      <a
        class="info-company__links-item__link"
        [href]="urlYouzful"
        target="_blank"
        aria-label="Youzful, vous souhaitez échanger avec des pros ?"
        (click)="eventTracker.emit('Youzful')"
      >
        <h3 class="info-company__links-item__title">Vous souhaitez échanger avec des pros&nbsp;?</h3>

        <img
          class="info-company__links-item__logo"
          [src]="srcLogoYouzful | imaginarySrc: 1:198"
          [srcset]="srcLogoYouzful | imaginarySrc: 4:198"
          alt="Logo de Youzful"
          loading="lazy"
        />
      </a>
    </li>
  </ul>
</section>
